import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const isGuidedTutorialOn = buildGetterObject('isGuidedTutorialOn');
export const guidedTutorials = buildGetterObject('guidedTutorials');
export const docsUrl = buildGetterObject('docsUrl');

const getters = {
	[isGuidedTutorialOn.getter]: (state) => state.isGuidedTutorialOn,
	[guidedTutorials.getter]: (state) => state.guidedTutorials,
	[docsUrl.getter]: (state) => state.docsUrl,
};

export default getters;
